import { Link } from "react-router-dom";
import { Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSubscription } from "@/hooks/useSubscription";
import { useSingleInstance } from "@/hooks/useSingleInstance";

// Mesmo padrão do TrialBanner: só a primeira instância montada renderiza,
// evitando duplicação quando Layout e EventLayout se aninham.
const BILLING_STATUSES = [
  "past_due",
  "unpaid",
  "canceled",
  "incomplete_expired",
  "incomplete",
  "paused",
];

export function NoSubscriptionBanner() {
  const { status, isActive, everSubscribed, hasLifetime, loading } =
    useSubscription();
  const isOwner = useSingleInstance("no-subscription-banner");

  // Mesma condição do painel de boas-vindas de primeiro acesso em Planos.tsx
  // (sem o `blocked` do router, que é específico da página /planos):
  // nunca assinou, sem acesso ativo agora, sem vitalício e fora dos estados
  // de cobrança/cancelamento — que têm seus próprios banners.
  const show =
    isOwner &&
    !loading &&
    !hasLifetime &&
    !everSubscribed &&
    !isActive &&
    !BILLING_STATUSES.includes(status ?? "");

  if (!show) return null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-border bg-muted px-6 py-3 text-foreground">
      <div className="flex items-center gap-2 text-sm font-medium">
        <Info className="h-4 w-4" />
        <span>Sua conta ainda não tem um plano ativo</span>
      </div>
      <Button asChild size="sm" variant="default">
        <Link to="/planos">Ver planos</Link>
      </Button>
    </div>
  );
}

export default NoSubscriptionBanner;
